{
  "box.1.label": "Afzender (naam, adres, land)",
  "box.2.label": "Geadresseerde (naam, adres, land)",
  "box.3.label": "Plaats van aflevering van de goederen (plaats, land)",
  "box.4.label": "Plaats en datum van inontvangstneming van de goederen (plaats, land, datum)",
  "box.5.label": "Bijgevoegde documenten",
  "box.6.label": "Merken en nummers",
  "box.7.label": "Aantal colli",
  "box.8.label": "Wijze van verpakking",
  "box.9.label": "Aard van de goederen",
  "box.10.label": "Statistieknummer",
  "box.11.label": "Brutogewicht in kg",
  "box.12.label": "Volume in m3",
  "box.13.label": "Instructies van de afzender",
  "box.14.label": "Frankering",
  "box.15.label": "Remboursement",
  "box.16.label": "Vervoerder (naam, adres, land)",
  "box.17.label": "Opvolgende vervoerders (naam, adres, land)",
  "box.18.label": "Voorbehoud en opmerkingen van de vervoerder",
  "box.19.label": "Bijzondere overeenkomsten",
  "box.20.label": "Te betalen door",
  "box.21.label": "Opgemaakt te, op",
  "box.22.label": "Handtekening en stempel van de afzender",
  "box.23.label": "Handtekening en stempel van de vervoerder",
  "box.24.label": "Goederen ontvangen (plaats, datum, handtekening en stempel van de geadresseerde)",
  "box.18.continued": "Niet alles past in dit vak. De volledige lijst van {total, plural, one {# voorbehoud} other {# voorbehouden}} staat in de bijlage op pagina {page}.",
  "annex.box18": "Bijlage vak 18 — voorbehoud en opmerkingen van de vervoerder",
  "document.title": "Internationale vrachtbrief",
  "document.convention_note": "Dit vervoer is, ongeacht enig tegenstrijdig beding, onderworpen aan het CMR-verdrag.",
  "document.ecmr_number": "Vrachtbriefnummer",
  "document.reference": "Referentie",
  "document.version": "Versie {version}",
  "document.continuation": "Vervolg",
  "document.page_of": "Pagina {page} van {pages}",
  "document.inspection_code": "Inspectiecode",
  "document.efti_certification": "eFTI-platform: niet gecertificeerd (test)",
  "label.vat_number": "Btw-nummer",
  "label.vehicle": "Voertuig",
  "label.trailer": "Aanhanger",
  "label.driver": "Chauffeur",
  "label.window": "Tijdvenster",
  "label.dangerous_goods": "Gevaarlijke goederen (ADR)",
  "label.adr_class": "Klasse",
  "label.adr_packing_group": "Verpakkingsgroep",
  "label.adr_tunnel_code": "Tunnelcode",
  "label.adr_limited_quantity": "Gelimiteerde hoeveelheid",
  "label.adr_environmentally_hazardous": "Milieugevaarlijk",
  "label.carriage_charges": "Vrachtkosten",
  "label.total": "Totaal",
  "value.payer.consignor": "Afzender",
  "value.payer.consignee": "Geadresseerde",
  "value.payer.principal": "Opdrachtgever",
  "value.carriage_paid": "Franco",
  "value.carriage_forward": "Niet franco",
  "value.package.pallet": "Pallet",
  "value.package.box": "Doos",
  "value.package.carton": "Karton",
  "value.package.crate": "Krat",
  "value.package.bag": "Zak",
  "value.package.drum": "Vat",
  "value.package.roll": "Rol",
  "value.package.bundle": "Bundel",
  "value.package.container": "Container",
  "value.package.loose": "Los gestort",
  "value.package.other": "Overig",
  "signature.signed_electronically": "Elektronisch getekend via Cargofollow",
  "signature.pending": "Nog niet getekend",
  "signature.method.drawn": "Getekend op scherm",
  "signature.method.click_otp": "Bevestigd met eenmalige code",
  "signature.method.api": "Getekend via de API",
  "signature.method.photo_of_paper": "Foto van papieren handtekening",
  "signature.trust.platform_auth": "Platformauthenticatie",
  "signature.trust.ades": "Geavanceerde handtekening (AdES)",
  "signature.trust.qes": "Gekwalificeerde handtekening (QES)",
  "signature.seal": "Zegel van een rechtspersoon",
  "label.signed_at": "Getekend op",
  "label.method": "Methode",
  "label.trust_level": "Betrouwbaarheidsniveau",
  "label.document_hash": "Documenthash",
  "label.location": "Locatie",
  "label.accuracy": "Nauwkeurigheid",
  "pod.title": "Proof of delivery",
  "pod.intro": "Bewijs van aflevering bij de bovenstaande vrachtbrief.",
  "pod.delivered_at": "Afgeleverd op",
  "pod.consignee_signature": "Handtekening van de geadresseerde",
  "pod.colli": "Collicontrole",
  "pod.colli_expected": "Aantal colli op de vrachtbrief",
  "pod.remarks": "Voorbehoud en opmerkingen",
  "pod.no_remarks": "Zonder voorbehoud afgeleverd.",
  "pod.remarks_on_form": "Niet alles past hier. De volledige lijst staat in vak 18 van de vrachtbrief op pagina 1.",
  "pod.photos": "Foto's",
  "pod.photos_omitted": "{count} foto(s) niet afgebeeld om het document klein te houden.",
  "pod.remark.phase.pickup": "Bij inontvangstneming",
  "pod.remark.phase.delivery": "Bij aflevering",
  "pod.remark.type.damage": "Schade",
  "pod.remark.type.shortage": "Manco",
  "pod.remark.type.delay": "Vertraging",
  "pod.remark.type.other": "Overig"
}
